(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("lodash/get"), require("lodash/has"), require("lodash/extend"), require("lodash/isFunction"), require("lodash/includes"), require("lodash/toLower"), require("lodash/toUpper"), require("lodash/isEmpty"), require("lodash/forEach"), require("lodash/omit"), require("@bytel/bytel-oauth"), require("lodash/set"), require("bluebird"), require("lodash/map"), require("lodash/each"), require("lodash/pick"), require("lodash/find"), require("lodash/filter"), require("lodash/uniq"), require("lodash/concat"), require("lodash/upperFirst"), require("lodash/intersection"), require("lodash/isArray"), require("@bytel/bytel-api"), require("loglevel"), require("lodash/isString"), require("localforage"), require("localforage-sessionstoragewrapper"));else if (typeof define === 'function' && define.amd) define(["lodash/get", "lodash/has", "lodash/extend", "lodash/isFunction", "lodash/includes", "lodash/toLower", "lodash/toUpper", "lodash/isEmpty", "lodash/forEach", "lodash/omit", "@bytel/bytel-oauth", "lodash/set", "bluebird", "lodash/map", "lodash/each", "lodash/pick", "lodash/find", "lodash/filter", "lodash/uniq", "lodash/concat", "lodash/upperFirst", "lodash/intersection", "lodash/isArray", "@bytel/bytel-api", "loglevel", "lodash/isString", "localforage", "localforage-sessionstoragewrapper"], factory);else if (typeof exports === 'object') exports["bytelTC"] = factory(require("lodash/get"), require("lodash/has"), require("lodash/extend"), require("lodash/isFunction"), require("lodash/includes"), require("lodash/toLower"), require("lodash/toUpper"), require("lodash/isEmpty"), require("lodash/forEach"), require("lodash/omit"), require("@bytel/bytel-oauth"), require("lodash/set"), require("bluebird"), require("lodash/map"), require("lodash/each"), require("lodash/pick"), require("lodash/find"), require("lodash/filter"), require("lodash/uniq"), require("lodash/concat"), require("lodash/upperFirst"), require("lodash/intersection"), require("lodash/isArray"), require("@bytel/bytel-api"), require("loglevel"), require("lodash/isString"), require("localforage"), require("localforage-sessionstoragewrapper"));else root["bytelTC"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function (__WEBPACK_EXTERNAL_MODULE_lodash_get__, __WEBPACK_EXTERNAL_MODULE_lodash_has__, __WEBPACK_EXTERNAL_MODULE_lodash_extend__, __WEBPACK_EXTERNAL_MODULE_lodash_isFunction__, __WEBPACK_EXTERNAL_MODULE_lodash_includes__, __WEBPACK_EXTERNAL_MODULE_lodash_toLower__, __WEBPACK_EXTERNAL_MODULE_lodash_toUpper__, __WEBPACK_EXTERNAL_MODULE_lodash_isEmpty__, __WEBPACK_EXTERNAL_MODULE_lodash_forEach__, __WEBPACK_EXTERNAL_MODULE_lodash_omit__, __WEBPACK_EXTERNAL_MODULE__bytel_bytel_oauth__, __WEBPACK_EXTERNAL_MODULE_lodash_set__, __WEBPACK_EXTERNAL_MODULE_bluebird__, __WEBPACK_EXTERNAL_MODULE_lodash_map__, __WEBPACK_EXTERNAL_MODULE_lodash_each__, __WEBPACK_EXTERNAL_MODULE_lodash_pick__, __WEBPACK_EXTERNAL_MODULE_lodash_find__, __WEBPACK_EXTERNAL_MODULE_lodash_filter__, __WEBPACK_EXTERNAL_MODULE_lodash_uniq__, __WEBPACK_EXTERNAL_MODULE_lodash_concat__, __WEBPACK_EXTERNAL_MODULE_lodash_upperFirst__, __WEBPACK_EXTERNAL_MODULE_lodash_intersection__, __WEBPACK_EXTERNAL_MODULE_lodash_isArray__, __WEBPACK_EXTERNAL_MODULE__bytel_bytel_api__, __WEBPACK_EXTERNAL_MODULE_loglevel__, __WEBPACK_EXTERNAL_MODULE_lodash_isString__, __WEBPACK_EXTERNAL_MODULE_localforage__, __WEBPACK_EXTERNAL_MODULE_localforage_sessionstoragewrapper__) {
  return /******/(() => {
    // webpackBootstrap
    /******/
    "use strict";

    /******/
    var __webpack_modules__ = {
      /***/"./src/utils/api.js": (
      /*!**************************!*\
        !*** ./src/utils/api.js ***!
        \**************************/
      /***/
      (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
          /* harmony export */
        });
        /* harmony import */
        var lodash_extend__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/extend */"lodash/extend");
        /* harmony import */
        var lodash_extend__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_extend__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var _bytel_bytel_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @bytel/bytel-api */"@bytel/bytel-api");
        /* harmony import */
        var _bytel_bytel_api__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_bytel_bytel_api__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */
        var _log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./log */"./src/utils/log.js");
        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }
        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
              args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);
              function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
              }
              function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
              }
              _next(undefined);
            });
          };
        }

        /* harmony default export */
        const __WEBPACK_DEFAULT_EXPORT__ = {
          setup: function setup() {
            var _arguments = arguments,
              _this = this;
            return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
              var options, host, accessToken, cache, bytelOptions;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      options = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                      _log__WEBPACK_IMPORTED_MODULE_2__["default"].debug('Setting up bytel-api using options:', options);
                      host = options.host, accessToken = options.accessToken, cache = options.cache;
                      bytelOptions = {
                        host: host,
                        cache: {
                          maxAge: 15 * 60 * 1000,
                          key: function key(req) {
                            return "bytel-tag-commander/".concat(req.url);
                          }
                        },
                        interceptors: {
                          authorization: {
                            accessToken: accessToken
                          }
                        }
                      };
                      bytelOptions.cache = lodash_extend__WEBPACK_IMPORTED_MODULE_0___default()(bytelOptions.cache, cache);
                      _context.next = 7;
                      return _bytel_bytel_api__WEBPACK_IMPORTED_MODULE_1___default().setup(bytelOptions);
                    case 7:
                      _this.get = _context.sent;
                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }))();
          },
          get: function get() {
            throw new Error('[ bytel-tag-commander ] Could not call bytel-api, it has not been setup yet');
          }
        };

        /***/
      }),
      /***/"./src/utils/client.js": (
      /*!*****************************!*\
        !*** ./src/utils/client.js ***!
        \*****************************/
      /***/
      (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
          /* harmony export */
        });
        /* harmony import */
        var bluebird__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bluebird */"bluebird");
        /* harmony import */
        var bluebird__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/get */"lodash/get");
        /* harmony import */
        var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */
        var lodash_has__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash/has */"lodash/has");
        /* harmony import */
        var lodash_has__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_has__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */
        var lodash_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lodash/map */"lodash/map");
        /* harmony import */
        var lodash_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_map__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */
        var lodash_each__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash/each */"lodash/each");
        /* harmony import */
        var lodash_each__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_each__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */
        var lodash_pick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lodash/pick */"lodash/pick");
        /* harmony import */
        var lodash_pick__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_pick__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */
        var lodash_find__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lodash/find */"lodash/find");
        /* harmony import */
        var lodash_find__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */
        var lodash_filter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lodash/filter */"lodash/filter");
        /* harmony import */
        var lodash_filter__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_filter__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */
        var lodash_uniq__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lodash/uniq */"lodash/uniq");
        /* harmony import */
        var lodash_uniq__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_uniq__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */
        var lodash_concat__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lodash/concat */"lodash/concat");
        /* harmony import */
        var lodash_concat__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_concat__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */
        var lodash_extend__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! lodash/extend */"lodash/extend");
        /* harmony import */
        var lodash_extend__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(lodash_extend__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */
        var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! lodash/isEmpty */"lodash/isEmpty");
        /* harmony import */
        var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */
        var lodash_isFunction__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! lodash/isFunction */"lodash/isFunction");
        /* harmony import */
        var lodash_isFunction__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(lodash_isFunction__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */
        var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! lodash/upperFirst */"lodash/upperFirst");
        /* harmony import */
        var lodash_upperFirst__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(lodash_upperFirst__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */
        var lodash_intersection__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! lodash/intersection */"lodash/intersection");
        /* harmony import */
        var lodash_intersection__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(lodash_intersection__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */
        var lodash_isArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! lodash/isArray */"lodash/isArray");
        /* harmony import */
        var lodash_isArray__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(lodash_isArray__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */
        var _api__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./api */"./src/utils/api.js");
        /* harmony import */
        var _store__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./store */"./src/utils/store.js");

        /* harmony default export */
        const __WEBPACK_DEFAULT_EXPORT__ = {
          getData: function getData() {
            var _this = this;
            return this.getUserType().then(function (userType) {
              if (userType !== 'CLIENT') return {
                userType: userType
              };
              return _this.getPersonId().then(function (personId) {
                if (!personId) return bluebird__WEBPACK_IMPORTED_MODULE_0___default().resolve({});
                return _this.getPerson(personId).then(function (person) {
                  return _this.getContracts(person).then(function (contracts) {
                    return {
                      userType: userType,
                      person: person,
                      contracts: contracts
                    };
                  });
                }, function () {
                  return null;
                });
              });
            });
          },
          getRenewEligibility: function getRenewEligibility(contractId) {
            return this.getContract(contractId).then(function (contract) {
              var path = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contract, '_links.eligibilitesRenouvellement.href');
              if (!path) throw new Error('Missing eligibility link');
              return _api__WEBPACK_IMPORTED_MODULE_16__["default"].get({
                path: path
              });
            }).then(function (eligibility) {
              var item = lodash_find__WEBPACK_IMPORTED_MODULE_6___default()(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(eligibility, 'items'), {
                type: 'renouvellement'
              });
              if (!item) throw new Error('Missing eligibility item');
              return item.statut;
            })["catch"](function () {
              return false;
            });
          },
          getContract: function getContract(contractId) {
            var path = "/contrats/".concat(contractId);
            return _api__WEBPACK_IMPORTED_MODULE_16__["default"].get({
              path: path
            });
          },
          getUserType: function getUserType() {
            return bluebird__WEBPACK_IMPORTED_MODULE_0___default().resolve((0, _store__WEBPACK_IMPORTED_MODULE_17__.getCache)().getItem('user-type'));
          },
          getPersonId: function getPersonId() {
            return bluebird__WEBPACK_IMPORTED_MODULE_0___default().resolve((0, _store__WEBPACK_IMPORTED_MODULE_17__.getCache)().getItem('person-id'));
          },
          getType: function getType(person) {
            var type = 'non identifié';
            if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(person)) {
              if (lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(person, '_links.contratsSignes.href') || lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(person, '_links.contratsUtilises.href')) {
                type = 'client';
              } else {
                type = 'prospect';
              }
            }
            return type;
          },
          getPerson: function getPerson(id) {
            var path = "/personnes/".concat(id);
            return _api__WEBPACK_IMPORTED_MODULE_16__["default"].get({
              path: path
            })["catch"](function () {
              return null;
            });
          },
          getContracts: function getContracts(person) {
            var path = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(person, '_links.contratsSignes.href') || lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(person, '_links.contratsUtilises.href');
            if (!path) return bluebird__WEBPACK_IMPORTED_MODULE_0___default().resolve([]);
            return _api__WEBPACK_IMPORTED_MODULE_16__["default"].get({
              path: path
            })["catch"](function () {
              return [];
            });
          },
          getMobileUsage: function getMobileUsage(equipementMobile) {
            var path = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(equipementMobile, 'mobileUsage.produit.href');
            if (!path) return bluebird__WEBPACK_IMPORTED_MODULE_0___default().resolve({});
            return _api__WEBPACK_IMPORTED_MODULE_16__["default"].get({
              path: path
            })["catch"](function () {
              return {};
            });
          },
          getContractIds: function getContractIds(contracts) {
            contracts = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contracts, 'items', contracts) || [];
            return lodash_map__WEBPACK_IMPORTED_MODULE_3___default()(filterActiveContracts(contracts), function (contract) {
              return contract.id;
            });
          },
          getCategory: function getCategory(person, contracts) {
            if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_11___default()(person)) return '';
            contracts = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contracts, 'items', contracts) || [];
            if (isTitulaire(person)) return 'titulaire';else if (isDelegated(person, contracts)) return 'délégué';else if (isRestricted(person, contracts)) return 'restreint';
          },
          checkContractByContract: function checkContractByContract(contracts, offers) {
            var gamme = [];
            gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, getFnb(offers));
            gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, getFixe(offers));
            lodash_each__WEBPACK_IMPORTED_MODULE_4___default()(contracts, function (contract) {
              if (isFaim(contract)) gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, ['FAIM']);else if (isCarte(contract)) gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, ['CARTE']);else if (isTokyo(contract)) gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, ['TOKYO']);else if (isFb(contract)) gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, ['FB']);
            });
            return lodash_uniq__WEBPACK_IMPORTED_MODULE_8___default()(gamme);
          }
        }; // --------
        // HELPER
        // --------

        function mapOfferIds(offer) {
          return lodash_map__WEBPACK_IMPORTED_MODULE_3___default()(lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(offer, 'famillesOffre', []), 'idFamilleOffre');
        }
        function getFnb(offers) {
          var gamme = [];
          lodash_each__WEBPACK_IMPORTED_MODULE_4___default()(offers, function (offer) {
            var offerFamilies = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(offer, 'famillesOffre', []);
            var foundOffer = lodash_find__WEBPACK_IMPORTED_MODULE_6___default()(offerFamilies, {
              typeFamilleOffre: "version d'offres"
            }); // Finds offer with the new typeFamilleOffre attribute

            if (foundOffer) {
              var offerFamilyLabel = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(foundOffer, 'libFamilleOffre');
              gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, [offerFamilyLabel]);
            } else {
              var offerId = mapOfferIds(offer);
              if (lodash_intersection__WEBPACK_IMPORTED_MODULE_14___default()(offerId, fieldsFnb.SENSATION).length !== 0) gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, ['FNB SENSATION']);else if (lodash_intersection__WEBPACK_IMPORTED_MODULE_14___default()(offerId, fieldsFnb.BYOU).length !== 0) gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, ['FNB BYOU']);else if (lodash_intersection__WEBPACK_IMPORTED_MODULE_14___default()(offerId, fieldsFnb.SIMO).length !== 0) gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, ['FNB SIMO']);
            }
          });
          return gamme;
        }
        function getFixe(offers) {
          var gamme = [];
          lodash_each__WEBPACK_IMPORTED_MODULE_4___default()(offers, function (offer) {
            var offerFamilies = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(offer, 'famillesOffre', []);
            var foundOffer = lodash_find__WEBPACK_IMPORTED_MODULE_6___default()(offerFamilies, {
              typeFamilleOffre: 'Standing'
            }); // Finds offer with the new typeFamilleOffre attribute

            if (foundOffer) {
              var offerFamilyLabel = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(foundOffer, 'libFamilleOffre');
              gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, [offerFamilyLabel]);
            } else {
              var offerId = mapOfferIds(offer);
              if (lodash_intersection__WEBPACK_IMPORTED_MODULE_14___default()(offerId, fieldsFixe.STANDARD).length !== 0) gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, ['FIXE STANDARD']);else if (lodash_intersection__WEBPACK_IMPORTED_MODULE_14___default()(offerId, fieldsFixe.SENSATION).length !== 0) gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, ['FIXE SENSATION']);else if (lodash_intersection__WEBPACK_IMPORTED_MODULE_14___default()(offerId, fieldsFixe.MIAMI).length !== 0) gamme = lodash_concat__WEBPACK_IMPORTED_MODULE_9___default()(gamme, ['FIXE MIAMI']);
            }
          });
          return gamme;
        }
        function filterContratEquipementMobibles(contracts) {
          return lodash_filter__WEBPACK_IMPORTED_MODULE_7___default()(contracts, function (contract) {
            return isEquipementMobiles(contract);
          });
        }
        function isEquipementMobiles(contrat) {
          return lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contrat, '_links.equipementsMobiles.href');
        }
        function filterEquipementMobilesByMobilesUsage(equipementsMobiles) {
          return lodash_filter__WEBPACK_IMPORTED_MODULE_7___default()(equipementsMobiles, function (equipementMobile) {
            return isMobileUsage(equipementMobile);
          });
        }
        function isMobileUsage(equipementMobile) {
          return lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(equipementMobile, 'mobileUsage.produit.href');
        }
        function filterTypeLignesPossedes(contracts) {
          contracts = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contracts, 'items', contracts) || [];
          return lodash_filter__WEBPACK_IMPORTED_MODULE_7___default()(contracts, function (contract) {
            return typeLignePossede(contract);
          });
        }
        function typeLignePossede(contract) {
          var typeLigne = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contract, 'typeLigne');
          return typeLigne === 'MOBILE' || typeLigne === 'FIXE';
        }
        function filterActiveContracts(contracts) {
          contracts = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contracts, 'items', contracts) || [];
          return lodash_filter__WEBPACK_IMPORTED_MODULE_7___default()(contracts, function (contract) {
            return contractIsActive(contract);
          });
        }
        function contractIsActive(contract) {
          var status = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contract, 'statut');
          return status === 'ACTIF' || status === 'SUSPENDU';
        }
        function isTitulaire(person) {
          return lodash_has__WEBPACK_IMPORTED_MODULE_2___default()(person, '_links.contratsSignes.href');
        }
        function isDelegated(person, contracts) {
          return hasOnlyDelegatedUser(contracts) && !isTitulaire(person);
        }
        function isRestricted(person, contracts) {
          return hasOnlyRestrictedUser(contracts) && !isTitulaire(person);
        }
        function hasOnlyDelegatedUser(contracts) {
          contracts = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contracts, 'items', contracts) || [];
          return lodash_filter__WEBPACK_IMPORTED_MODULE_7___default()(contracts, hasDelegatedUser).length === contracts.length;
        }
        function hasOnlyRestrictedUser(contracts) {
          contracts = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contracts, 'items', contracts) || [];
          return lodash_filter__WEBPACK_IMPORTED_MODULE_7___default()(contracts, hasRestrictedUser).length === contracts.length;
        }
        function hasDelegatedUser(contract) {
          return hasProfileRights(contract, '2');
        }
        function hasRestrictedUser(contract) {
          return hasProfileRights(contract, '3');
        }
        function hasProfileRights(contract, rights) {
          return lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contract, 'utilisateur.profilDroits') === rights;
        } // ---------------------
        // const helper gamme
        // ---------------------

        var fields = {
          FNB: 'FNB',
          FB: 'FB',
          CARTE: 'CARTE',
          FAIM: 'FAIM'
        };
        var fieldsFnb = {
          'SENSATION': ['150'],
          'BYOU': ['151', '152'],
          'SIMO': ['342']
        };
        var fieldsFixe = {
          'STANDARD': ['10017'],
          'SENSATION': ['10018'],
          'MIAMI': ['10019']
        }; // ----------------------------

        function checkContratType(contrat, type) {
          return checkContrat(contrat) === type;
        }
        function checkContrat(contrat) {
          contrat = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contrat, 'attributes', contrat);
          if (contrat.partitionSic === 1) {
            return fields.FNB;
          }
          if (contrat.partitionSic === 2) {
            if (lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contrat, 'abonnement.libFamilleOffre') === 'CARTE PREPAYEE') {
              return fields.CARTE;
            }
            return fields.FB;
          }
          return false;
        }
        function isFnb(contrat) {
          return checkContratType(contrat, 'FNB');
        }
        function isFb(contrat) {
          return checkContratType(contrat, 'FB');
        }
        function isFaim(contrat) {
          contrat = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contrat, 'attributes', contrat);
          return lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contrat, 'abonnement.offreDataMobile') === true;
        }
        function isTokyo(contrat) {
          contrat = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contrat, 'attributes', contrat);
          return lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contrat, 'abonnement.offreTokyo');
        }
        function isCarte(contrat) {
          return checkContratType(contrat, 'CARTE');
        }
        function hasOnlyFNB(contrats) {
          return contrats.filter(isFnb).length === contrats.length;
        }
        function hasOnlyFB(contrats) {
          return contrats.filter(isFb).length === contrats.length;
        }
        function hasOnlyCarte(contracts) {
          return hasOnlyType(contracts, 'carte');
        }
        function hasOnlyType(contracts, type) {
          // Support literal arrays and backbone collections
          contracts = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contracts, 'models', contracts); // Retrieve a list of contracts with the given type

          var filteredContracts = lodash_filter__WEBPACK_IMPORTED_MODULE_7___default()(contracts, function (contract) {
            return filterByTypeAndStatus(contract, type);
          }); // Check if both lists have the same length

          return filteredContracts.length === contracts.length;
        }
        function filterByTypeAndStatus(contract, types, filterStatus) {
          var hasContractType = false;
          var contractData = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(contract, 'attributes', contract);
          types = lodash_isArray__WEBPACK_IMPORTED_MODULE_15___default()(types) ? types : [types]; // Checking if contract type is in the defined list of contract types for the executed route

          for (var i = 0; i < types.length; i += 1) {
            var type = types[i]; // Check if a type is negated

            if (type.charAt(0) === '!' && hasCaracteristic(type.substr(1), contractData)) {
              break;
            }
            if (type === 'any' || hasCaracteristic(type, contractData)) {
              hasContractType = true;
              break;
            }
          }
          if (!hasContractType) {
            return false;
          } // Checking if contract filterStatus is in the defined list of contract filterStatus' for the executed route

          return !filterStatus || filterStatus === 'any' || filterStatus && this.hasCaracteristic(filterStatus, contractData);
        }
        function hasCaracteristic(caracteristic, contract) {
          var methodName = 'is' + lodash_upperFirst__WEBPACK_IMPORTED_MODULE_13___default()(caracteristic);
          return lodash_isFunction__WEBPACK_IMPORTED_MODULE_12___default()([methodName]) && [methodName](contract);
        }

        /***/
      }),
      /***/"./src/utils/log.js": (
      /*!**************************!*\
        !*** ./src/utils/log.js ***!
        \**************************/
      /***/
      (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
          /* harmony export */
        });
        /* harmony import */
        var loglevel__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! loglevel */"loglevel");
        /* harmony import */
        var loglevel__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(loglevel__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var lodash_isString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/isString */"lodash/isString");
        /* harmony import */
        var lodash_isString__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isString__WEBPACK_IMPORTED_MODULE_1__);
        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
        }
        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
        }
        function _iterableToArray(iter) {
          if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
        }
        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) return _arrayLikeToArray(arr);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) {
            arr2[i] = arr[i];
          }
          return arr2;
        }
        loglevel__WEBPACK_IMPORTED_MODULE_0___default().setDefaultLevel('warn');
        function printLog(level) {
          var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          if (args.length && lodash_isString__WEBPACK_IMPORTED_MODULE_1___default()(args[0])) {
            args[0] = "[ bytel-tag-commander ] ".concat(args[0]);
          }
          return loglevel__WEBPACK_IMPORTED_MODULE_0___default()[level].apply(loglevel__WEBPACK_IMPORTED_MODULE_0___default(), _toConsumableArray(args));
        }

        /* harmony default export */
        const __WEBPACK_DEFAULT_EXPORT__ = {
          setLevel: function setLevel() {
            return loglevel__WEBPACK_IMPORTED_MODULE_0___default().setLevel.apply(loglevel__WEBPACK_IMPORTED_MODULE_0___default(), arguments);
          },
          setDefaultLevel: function setDefaultLevel() {
            return loglevel__WEBPACK_IMPORTED_MODULE_0___default().setDefaultLevel.apply(loglevel__WEBPACK_IMPORTED_MODULE_0___default(), arguments);
          },
          debug: function debug() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            return printLog('debug', args);
          },
          info: function info() {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            return printLog('info', args);
          },
          warn: function warn() {
            for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }
            return printLog('warn', args);
          },
          error: function error() {
            for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              args[_key4] = arguments[_key4];
            }
            return printLog('error', args);
          }
        };

        /***/
      }),
      /***/"./src/utils/partial.js": (
      /*!******************************!*\
        !*** ./src/utils/partial.js ***!
        \******************************/
      /***/
      (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
          /* harmony export */
        });
        function partial(fn) {
          for (var _len = arguments.length, partials = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            partials[_key - 1] = arguments[_key];
          }
          return function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            return fn.apply(void 0, partials.concat(args));
          };
        }

        /* harmony default export */
        const __WEBPACK_DEFAULT_EXPORT__ = partial;

        /***/
      }),
      /***/"./src/utils/store.js": (
      /*!****************************!*\
        !*** ./src/utils/store.js ***!
        \****************************/
      /***/
      (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"setDriver": () => (/* binding */setDriver),
          /* harmony export */"getCache": () => (/* binding */getCache)
          /* harmony export */
        });
        /* harmony import */
        var localforage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! localforage */"localforage");
        /* harmony import */
        var localforage__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(localforage__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var localforage_sessionstoragewrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! localforage-sessionstoragewrapper */"localforage-sessionstoragewrapper");
        /* harmony import */
        var localforage_sessionstoragewrapper__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(localforage_sessionstoragewrapper__WEBPACK_IMPORTED_MODULE_1__);
        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }
          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }
        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
              args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);
              function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
              }
              function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
              }
              _next(undefined);
            });
          };
        }
        function setDriver() {
          return _setDriver.apply(this, arguments);
        }
        function _setDriver() {
          _setDriver = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return localforage__WEBPACK_IMPORTED_MODULE_0___default().defineDriver(localforage_sessionstoragewrapper__WEBPACK_IMPORTED_MODULE_1___default());
                  case 2:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return _setDriver.apply(this, arguments);
        }
        var store;
        function getCache() {
          if (store) {
            return store;
          }
          store = localforage__WEBPACK_IMPORTED_MODULE_0___default().createInstance({
            driver: [localforage_sessionstoragewrapper__WEBPACK_IMPORTED_MODULE_1___default()._driver, localforage__WEBPACK_IMPORTED_MODULE_0___default().LOCALSTORAGE],
            name: 'bytel-tag-commander'
          });
          return store;
        }

        /***/
      }),
      /***/"./src/utils/tc-vars.js": (
      /*!******************************!*\
        !*** ./src/utils/tc-vars.js ***!
        \******************************/
      /***/
      (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
          /* harmony export */
        });
        /* harmony import */
        var lodash_set__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/set */"lodash/set");
        /* harmony import */
        var lodash_set__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_set__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */
        var lodash_extend__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/extend */"lodash/extend");
        /* harmony import */
        var lodash_extend__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_extend__WEBPACK_IMPORTED_MODULE_1__);

        // Setup default tag commander variables

        var defaultTcVars = {
          // -----------------
          // Client data
          // -----------------
          // CLIENT / CDC / CDV / SUPPORT (oauth)
          typeUtilisateur: '',
          // Connecté / Non Connecté (oauth)
          connexion: false,
          // Infos client
          structureClient: {
            idPersonne: '',
            idsContrat: []
          },
          // -----------------
          // Environment data
          // -----------------
          // DEV / BETA / PROD
          env: 'PROD',
          // espace_client / magento / etc
          site: '',
          // -----------------
          // Page data
          // -----------------
          univers: '',
          parcours: '',
          pageCategorie: '',
          page: ''
        };
        var permanentStore = {}; // Public export

        /* harmony default export */
        const __WEBPACK_DEFAULT_EXPORT__ = {
          /**
           * Store tc_vars data permanently
           *
           * @param  {object} data Data object to store in tc_vars
           * @return {object}      Modified tc_vars object
           */
          store: function store(data) {
            permanentStore = lodash_extend__WEBPACK_IMPORTED_MODULE_1___default()(permanentStore, data);
            defaultTcVars = lodash_extend__WEBPACK_IMPORTED_MODULE_1___default()(defaultTcVars, permanentStore, data);
            return defaultTcVars;
          },
          /**
           * Set tc_vars data temporarily
           *
           * @param  {object} data Data object to store in tc_vars
           * @return {object}      The modified `tc_vars` object
           */
          set: function set(data) {
            // Clear `nomClic`, 'acte' and 'categorieActe' var to prevent data colisions
            lodash_set__WEBPACK_IMPORTED_MODULE_0___default()(window.tc_vars, 'nomClic', '');
            lodash_set__WEBPACK_IMPORTED_MODULE_0___default()(window.tc_vars, 'acte', '');
            lodash_set__WEBPACK_IMPORTED_MODULE_0___default()(window.tc_vars, 'categorieActe', '');
            lodash_set__WEBPACK_IMPORTED_MODULE_0___default()(window.tc_vars, 'etapeEcommerce', '');
            lodash_set__WEBPACK_IMPORTED_MODULE_0___default()(window.tc_vars, 'pageVariante', ''); // Extend defaults with existing tc_vars data for multi lib compatibility

            window.tc_vars = lodash_extend__WEBPACK_IMPORTED_MODULE_1___default()(defaultTcVars, window.tc_vars, permanentStore, data);
            return window.tc_vars;
          }
        };

        /***/
      }),
      /***/"./src/utils/trackingHistory.js": (
      /*!**************************************!*\
        !*** ./src/utils/trackingHistory.js ***!
        \**************************************/
      /***/
      (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */
        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
          /* harmony export */
        });
        var trackingHistory = {
          shouldEmitEvent: false,
          hasHistory: false,
          setup: function setup(options) {
            this.shouldEmitEvent = options.shouldEmitEvent;
            this.hasHistory = options.hasHistory;
            if (this.hasHistory && !window.hasOwnProperty('trackingHistory')) {
              window.trackingHistory = [];
            }
          },
          sendEvent: function sendEvent(type, options) {
            var tracking = {
              tracking: options,
              type: type,
              date: new Date().toISOString()
            };
            if (this.hasHistory) {
              window.trackingHistory.push(tracking);
            }
            if (this.shouldEmitEvent) {
              // eslint-disable-next-line no-undef
              document.dispatchEvent(new CustomEvent('tracking:send', {
                detail: tracking
              }));
            }
          }
        };
        /* harmony default export */
        const __WEBPACK_DEFAULT_EXPORT__ = trackingHistory;

        /***/
      }),
      /***/"@bytel/bytel-api": (
      /*!*********************************************************************************************************************************!*\
        !*** external {"umd":"@bytel/bytel-api","amd":"@bytel/bytel-api","commonjs":"@bytel/bytel-api","commonjs2":"@bytel/bytel-api"} ***!
        \*********************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE__bytel_bytel_api__;

        /***/
      }),
      /***/"@bytel/bytel-oauth": (
      /*!*****************************************************************************************************************************************!*\
        !*** external {"umd":"@bytel/bytel-oauth","amd":"@bytel/bytel-oauth","commonjs":"@bytel/bytel-oauth","commonjs2":"@bytel/bytel-oauth"} ***!
        \*****************************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE__bytel_bytel_oauth__;

        /***/
      }),
      /***/"bluebird": (
      /*!*************************************************************************************************!*\
        !*** external {"umd":"bluebird","amd":"bluebird","commonjs":"bluebird","commonjs2":"bluebird"} ***!
        \*************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_bluebird__;

        /***/
      }),
      /***/"localforage": (
      /*!*************************************************************************************************************!*\
        !*** external {"umd":"localforage","amd":"localforage","commonjs":"localforage","commonjs2":"localforage"} ***!
        \*************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_localforage__;

        /***/
      }),
      /***/"localforage-sessionstoragewrapper": (
      /*!*****************************************************************************************************************************************************************************************************!*\
        !*** external {"umd":"localforage-sessionstoragewrapper","amd":"localforage-sessionstoragewrapper","commonjs":"localforage-sessionstoragewrapper","commonjs2":"localforage-sessionstoragewrapper"} ***!
        \*****************************************************************************************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_localforage_sessionstoragewrapper__;

        /***/
      }),
      /***/"lodash/concat": (
      /*!*********************************************************************************************************************!*\
        !*** external {"umd":"lodash/concat","amd":"lodash/concat","commonjs":"lodash/concat","commonjs2":"lodash/concat"} ***!
        \*********************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_concat__;

        /***/
      }),
      /***/"lodash/each": (
      /*!*************************************************************************************************************!*\
        !*** external {"umd":"lodash/each","amd":"lodash/each","commonjs":"lodash/each","commonjs2":"lodash/each"} ***!
        \*************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_each__;

        /***/
      }),
      /***/"lodash/extend": (
      /*!*********************************************************************************************************************!*\
        !*** external {"umd":"lodash/extend","amd":"lodash/extend","commonjs":"lodash/extend","commonjs2":"lodash/extend"} ***!
        \*********************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_extend__;

        /***/
      }),
      /***/"lodash/filter": (
      /*!*********************************************************************************************************************!*\
        !*** external {"umd":"lodash/filter","amd":"lodash/filter","commonjs":"lodash/filter","commonjs2":"lodash/filter"} ***!
        \*********************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_filter__;

        /***/
      }),
      /***/"lodash/find": (
      /*!*************************************************************************************************************!*\
        !*** external {"umd":"lodash/find","amd":"lodash/find","commonjs":"lodash/find","commonjs2":"lodash/find"} ***!
        \*************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_find__;

        /***/
      }),
      /***/"lodash/forEach": (
      /*!*************************************************************************************************************************!*\
        !*** external {"umd":"lodash/forEach","amd":"lodash/forEach","commonjs":"lodash/forEach","commonjs2":"lodash/forEach"} ***!
        \*************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_forEach__;

        /***/
      }),
      /***/"lodash/get": (
      /*!*********************************************************************************************************!*\
        !*** external {"umd":"lodash/get","amd":"lodash/get","commonjs":"lodash/get","commonjs2":"lodash/get"} ***!
        \*********************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_get__;

        /***/
      }),
      /***/"lodash/has": (
      /*!*********************************************************************************************************!*\
        !*** external {"umd":"lodash/has","amd":"lodash/has","commonjs":"lodash/has","commonjs2":"lodash/has"} ***!
        \*********************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_has__;

        /***/
      }),
      /***/"lodash/includes": (
      /*!*****************************************************************************************************************************!*\
        !*** external {"umd":"lodash/includes","amd":"lodash/includes","commonjs":"lodash/includes","commonjs2":"lodash/includes"} ***!
        \*****************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_includes__;

        /***/
      }),
      /***/"lodash/intersection": (
      /*!*********************************************************************************************************************************************!*\
        !*** external {"umd":"lodash/intersection","amd":"lodash/intersection","commonjs":"lodash/intersection","commonjs2":"lodash/intersection"} ***!
        \*********************************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_intersection__;

        /***/
      }),
      /***/"lodash/isArray": (
      /*!*************************************************************************************************************************!*\
        !*** external {"umd":"lodash/isArray","amd":"lodash/isArray","commonjs":"lodash/isArray","commonjs2":"lodash/isArray"} ***!
        \*************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isArray__;

        /***/
      }),
      /***/"lodash/isEmpty": (
      /*!*************************************************************************************************************************!*\
        !*** external {"umd":"lodash/isEmpty","amd":"lodash/isEmpty","commonjs":"lodash/isEmpty","commonjs2":"lodash/isEmpty"} ***!
        \*************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isEmpty__;

        /***/
      }),
      /***/"lodash/isFunction": (
      /*!*************************************************************************************************************************************!*\
        !*** external {"umd":"lodash/isFunction","amd":"lodash/isFunction","commonjs":"lodash/isFunction","commonjs2":"lodash/isFunction"} ***!
        \*************************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isFunction__;

        /***/
      }),
      /***/"lodash/isString": (
      /*!*****************************************************************************************************************************!*\
        !*** external {"umd":"lodash/isString","amd":"lodash/isString","commonjs":"lodash/isString","commonjs2":"lodash/isString"} ***!
        \*****************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isString__;

        /***/
      }),
      /***/"lodash/map": (
      /*!*********************************************************************************************************!*\
        !*** external {"umd":"lodash/map","amd":"lodash/map","commonjs":"lodash/map","commonjs2":"lodash/map"} ***!
        \*********************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_map__;

        /***/
      }),
      /***/"lodash/omit": (
      /*!*************************************************************************************************************!*\
        !*** external {"umd":"lodash/omit","amd":"lodash/omit","commonjs":"lodash/omit","commonjs2":"lodash/omit"} ***!
        \*************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_omit__;

        /***/
      }),
      /***/"lodash/pick": (
      /*!*************************************************************************************************************!*\
        !*** external {"umd":"lodash/pick","amd":"lodash/pick","commonjs":"lodash/pick","commonjs2":"lodash/pick"} ***!
        \*************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_pick__;

        /***/
      }),
      /***/"lodash/set": (
      /*!*********************************************************************************************************!*\
        !*** external {"umd":"lodash/set","amd":"lodash/set","commonjs":"lodash/set","commonjs2":"lodash/set"} ***!
        \*********************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_set__;

        /***/
      }),
      /***/"lodash/toLower": (
      /*!*************************************************************************************************************************!*\
        !*** external {"umd":"lodash/toLower","amd":"lodash/toLower","commonjs":"lodash/toLower","commonjs2":"lodash/toLower"} ***!
        \*************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_toLower__;

        /***/
      }),
      /***/"lodash/toUpper": (
      /*!*************************************************************************************************************************!*\
        !*** external {"umd":"lodash/toUpper","amd":"lodash/toUpper","commonjs":"lodash/toUpper","commonjs2":"lodash/toUpper"} ***!
        \*************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_toUpper__;

        /***/
      }),
      /***/"lodash/uniq": (
      /*!*************************************************************************************************************!*\
        !*** external {"umd":"lodash/uniq","amd":"lodash/uniq","commonjs":"lodash/uniq","commonjs2":"lodash/uniq"} ***!
        \*************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_uniq__;

        /***/
      }),
      /***/"lodash/upperFirst": (
      /*!*************************************************************************************************************************************!*\
        !*** external {"umd":"lodash/upperFirst","amd":"lodash/upperFirst","commonjs":"lodash/upperFirst","commonjs2":"lodash/upperFirst"} ***!
        \*************************************************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_upperFirst__;

        /***/
      }),
      /***/"loglevel": (
      /*!*************************************************************************************************!*\
        !*** external {"umd":"loglevel","amd":"loglevel","commonjs":"loglevel","commonjs2":"loglevel"} ***!
        \*************************************************************************************************/
      /***/
      module => {
        module.exports = __WEBPACK_EXTERNAL_MODULE_loglevel__;

        /***/
      })

      /******/
    };
    /************************************************************************/
    /******/ // The module cache
    /******/
    var __webpack_module_cache__ = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/ // Check if module is in cache
      /******/var cachedModule = __webpack_module_cache__[moduleId];
      /******/
      if (cachedModule !== undefined) {
        /******/return cachedModule.exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = __webpack_module_cache__[moduleId] = {
        /******/ // no module.id needed
        /******/ // no module.loaded needed
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /************************************************************************/
    /******/ /* webpack/runtime/compat get default export */
    /******/
    (() => {
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = module => {
        /******/var getter = module && module.__esModule ? /******/() => module['default'] : /******/() => module;
        /******/
        __webpack_require__.d(getter, {
          a: getter
        });
        /******/
        return getter;
        /******/
      };
      /******/
    })();
    /******/
    /******/ /* webpack/runtime/define property getters */
    /******/
    (() => {
      /******/ // define getter functions for harmony exports
      /******/__webpack_require__.d = (exports, definition) => {
        /******/for (var key in definition) {
          /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
            /******/Object.defineProperty(exports, key, {
              enumerable: true,
              get: definition[key]
            });
            /******/
          }
          /******/
        }
        /******/
      };
      /******/
    })();
    /******/
    /******/ /* webpack/runtime/hasOwnProperty shorthand */
    /******/
    (() => {
      /******/__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
      /******/
    })();
    /******/
    /******/ /* webpack/runtime/make namespace object */
    /******/
    (() => {
      /******/ // define __esModule on exports
      /******/__webpack_require__.r = exports => {
        /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/
        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/
    })();
    /******/
    /************************************************************************/
    var __webpack_exports__ = {};
    // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
    (() => {
      /*!**********************!*\
        !*** ./src/index.js ***!
        \**********************/
      __webpack_require__.r(__webpack_exports__);
      /* harmony export */
      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
        /* harmony export */
      });
      /* harmony import */
      var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/get */"lodash/get");
      /* harmony import */
      var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var lodash_has__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/has */"lodash/has");
      /* harmony import */
      var lodash_has__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_has__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var lodash_extend__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash/extend */"lodash/extend");
      /* harmony import */
      var lodash_extend__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_extend__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */
      var lodash_isFunction__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! lodash/isFunction */"lodash/isFunction");
      /* harmony import */
      var lodash_isFunction__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isFunction__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */
      var lodash_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lodash/includes */"lodash/includes");
      /* harmony import */
      var lodash_includes__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_includes__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */
      var lodash_toLower__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lodash/toLower */"lodash/toLower");
      /* harmony import */
      var lodash_toLower__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_toLower__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */
      var lodash_toUpper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lodash/toUpper */"lodash/toUpper");
      /* harmony import */
      var lodash_toUpper__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_toUpper__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */
      var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lodash/isEmpty */"lodash/isEmpty");
      /* harmony import */
      var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7__);
      /* harmony import */
      var lodash_forEach__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lodash/forEach */"lodash/forEach");
      /* harmony import */
      var lodash_forEach__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_forEach__WEBPACK_IMPORTED_MODULE_8__);
      /* harmony import */
      var lodash_omit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lodash/omit */"lodash/omit");
      /* harmony import */
      var lodash_omit__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_9__);
      /* harmony import */
      var _bytel_bytel_oauth__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @bytel/bytel-oauth */"@bytel/bytel-oauth");
      /* harmony import */
      var _bytel_bytel_oauth__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_bytel_bytel_oauth__WEBPACK_IMPORTED_MODULE_10__);
      /* harmony import */
      var _utils_partial__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./utils/partial */"./src/utils/partial.js");
      /* harmony import */
      var _utils_tc_vars__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./utils/tc-vars */"./src/utils/tc-vars.js");
      /* harmony import */
      var _utils_client__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./utils/client */"./src/utils/client.js");
      /* harmony import */
      var _utils_store__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./utils/store */"./src/utils/store.js");
      /* harmony import */
      var _utils_api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./utils/api */"./src/utils/api.js");
      /* harmony import */
      var _utils_log__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./utils/log */"./src/utils/log.js");
      /* harmony import */
      var _utils_trackingHistory__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./utils/trackingHistory */"./src/utils/trackingHistory.js");
      function _createForOfIteratorHelper(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (!it) {
          if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
              s: F,
              n: function n() {
                if (i >= o.length) return {
                  done: true
                };
                return {
                  done: false,
                  value: o[i++]
                };
              },
              e: function e(_e) {
                throw _e;
              },
              f: F
            };
          }
          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var normalCompletion = true,
          didErr = false,
          err;
        return {
          s: function s() {
            it = it.call(o);
          },
          n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
          },
          e: function e(_e2) {
            didErr = true;
            err = _e2;
          },
          f: function f() {
            try {
              if (!normalCompletion && it["return"] != null) it["return"]();
            } finally {
              if (didErr) throw err;
            }
          }
        };
      }
      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }
      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      }
      function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          enumerableOnly && (symbols = symbols.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          })), keys.push.apply(keys, symbols);
        }
        return keys;
      }
      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = null != arguments[i] ? arguments[i] : {};
          i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
            _defineProperty(target, key, source[key]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
        return target;
      }
      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
      }
      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }
      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
            args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
          });
        };
      }

      /**
       * @module bytel-tag-commander
       * @description Library to send tagging informations from bytel applications
       */

      // Default setup options

      var defaultOptions = {
        send: 'tc_events_2',
        debug: false,
        shouldEmitEvent: false,
        hasHistory: false
      };
      var eventTypes = {
        click: 'clic',
        impression: 'imp'
      };
      var tag = {
        /**
         * Setup tagging library. Needs to be called before sending any data
         *
         * @function setup
         * @public
         *
         * @param  {Object}  options Setup options
         * @return {Promise}         Bluebird promise
         */
        setup: function setup(options) {
          return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var _options, host, env, site, cache, debug;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (0, _utils_store__WEBPACK_IMPORTED_MODULE_14__.setDriver)();
                  case 2:
                    options = _objectSpread(_objectSpread({}, defaultOptions), options);
                    _options = options, host = _options.host, env = _options.env, site = _options.site, cache = _options.cache, debug = _options.debug;
                    _utils_trackingHistory__WEBPACK_IMPORTED_MODULE_17__["default"].setup(options);
                    _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].setDefaultLevel(debug ? 'trace' : 'error');
                    _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].debug('Setting up...');
                    return _context.abrupt("return", (0, _utils_store__WEBPACK_IMPORTED_MODULE_14__.getCache)().clear().then((0, _utils_partial__WEBPACK_IMPORTED_MODULE_11__["default"])(storeOptions, options)).then((0, _utils_partial__WEBPACK_IMPORTED_MODULE_11__["default"])(connect, options.oauth)).then((0, _utils_partial__WEBPACK_IMPORTED_MODULE_11__["default"])(apiSetup, host, cache)).then(function () {
                      return _utils_tc_vars__WEBPACK_IMPORTED_MODULE_12__["default"].store({
                        env: env,
                        site: site
                      });
                    }));
                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))();
        },
        /**
         * Send tag data
         *
         * @function send
         * @public
         *
         * @param  {Object}  options Custom data to send
         * @return {Promise}         Bluebird promise
         */
        send: function send(options) {
          _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].debug('Preparing tag data using options:', options);
          options = standardizeVars(options);
          return _utils_client__WEBPACK_IMPORTED_MODULE_13__["default"].getData().then((0, _utils_partial__WEBPACK_IMPORTED_MODULE_11__["default"])(setClientData, options))["finally"]((0, _utils_partial__WEBPACK_IMPORTED_MODULE_11__["default"])(sendTag, options));
        },
        /**
         * `bytel-tag-commander` localForage instance
         *
         * @type {object}
         */
        store: function store() {
          return (0, _utils_store__WEBPACK_IMPORTED_MODULE_14__.getCache)();
        },
        /**
         * Fetch client renew eligibility
         *
         * @param   {string} contractId The contract id to check
         * @returns {Promise}           Resolves with a boolean
         */
        getRenewEligibility: function getRenewEligibility(contractId) {
          return _utils_client__WEBPACK_IMPORTED_MODULE_13__["default"].getRenewEligibility(contractId);
        }
      };
      /* eslint-disable */

      var DEFAULT_DIACRITICS_REMOVAL_MAP = [{
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
      }, {
        base: 'AA',
        letters: "\uA732"
      }, {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
      }, {
        base: 'AO',
        letters: "\uA734"
      }, {
        base: 'AU',
        letters: "\uA736"
      }, {
        base: 'AV',
        letters: "\uA738\uA73A"
      }, {
        base: 'AY',
        letters: "\uA73C"
      }, {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
      }, {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
      }, {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
      }, {
        base: 'DZ',
        letters: "\u01F1\u01C4"
      }, {
        base: 'Dz',
        letters: "\u01F2\u01C5"
      }, {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
      }, {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
      }, {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
      }, {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
      }, {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
      }, {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
      }, {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
      }, {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
      }, {
        base: 'LJ',
        letters: "\u01C7"
      }, {
        base: 'Lj',
        letters: "\u01C8"
      }, {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
      }, {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
      }, {
        base: 'NJ',
        letters: "\u01CA"
      }, {
        base: 'Nj',
        letters: "\u01CB"
      }, {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
      }, {
        base: 'OI',
        letters: "\u01A2"
      }, {
        base: 'OO',
        letters: "\uA74E"
      }, {
        base: 'OU',
        letters: "\u0222"
      }, {
        base: 'OE',
        letters: "\x8C\u0152"
      }, {
        base: 'oe',
        letters: "\x9C\u0153"
      }, {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
      }, {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
      }, {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
      }, {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
      }, {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
      }, {
        base: 'TZ',
        letters: "\uA728"
      }, {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
      }, {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
      }, {
        base: 'VY',
        letters: "\uA760"
      }, {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
      }, {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
      }, {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
      }, {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
      }, {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
      }, {
        base: 'aa',
        letters: "\uA733"
      }, {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
      }, {
        base: 'ao',
        letters: "\uA735"
      }, {
        base: 'au',
        letters: "\uA737"
      }, {
        base: 'av',
        letters: "\uA739\uA73B"
      }, {
        base: 'ay',
        letters: "\uA73D"
      }, {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
      }, {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
      }, {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
      }, {
        base: 'dz',
        letters: "\u01F3\u01C6"
      }, {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
      }, {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
      }, {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
      }, {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
      }, {
        base: 'hv',
        letters: "\u0195"
      }, {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
      }, {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
      }, {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
      }, {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
      }, {
        base: 'lj',
        letters: "\u01C9"
      }, {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
      }, {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
      }, {
        base: 'nj',
        letters: "\u01CC"
      }, {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
      }, {
        base: 'oi',
        letters: "\u01A3"
      }, {
        base: 'ou',
        letters: "\u0223"
      }, {
        base: 'oo',
        letters: "\uA74F"
      }, {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
      }, {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
      }, {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
      }, {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
      }, {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
      }, {
        base: 'tz',
        letters: "\uA729"
      }, {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
      }, {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
      }, {
        base: 'vy',
        letters: "\uA761"
      }, {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
      }, {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
      }, {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
      }, {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
      }];
      /* eslint-enable */

      var STANDARDIZED_VAR_NAMES = {
        SITE: 'site',
        LIGNE_MARCHE: 'ligneMarche',
        UNIVERS: 'univers',
        PARCOURS: 'parcours',
        PAGE_CATEGORIE: 'pageCategorie',
        PAGE: 'page',
        PAGE_VARIANTE: 'pageVariante',
        ACTE: 'acte',
        CATEGORIE_ACTE: 'categorieActe',
        ACTIVITE: 'activiteB2BouB2C',
        ETAPE_E_COMMERCE: 'etapeEcommerce'
      };
      var ACTIVITIES = ['B2B', 'B2C', 'B2C_ET_B2B'];
      /* harmony default export */
      const __WEBPACK_DEFAULT_EXPORT__ = tag; // module.exports = tag
      // -----------------------
      // Helper methods
      // -----------------------

      /**
       * Interpret and store the client data in `window.tc_vars` for tag commander to pick up.
       * This method receives the specific `options` for the current tag to send and the `data` that was
       * automatically fetched from bytel APIs in case the user is connected.
       *
       * @private
       *
       * @param  {Object} options Specific options for current tag
       * @param  {Object} data    Client data fetched from bytel APIs
       * @return {Object}         The merged data that is actually given to tag commander
       */

      function setClientData(options, data) {
        _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].debug('Setting client data');
        var typeUtilisateur = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(data, 'userType', '');
        var contracts = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(data, 'contracts', []);
        var person = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(data, 'person', {});
        var tagData = lodash_extend__WEBPACK_IMPORTED_MODULE_2___default()({
          typeUtilisateur: typeUtilisateur,
          connexion: Boolean(typeUtilisateur),
          structureClient: {
            id_personne: person.id,
            idsContrat: _utils_client__WEBPACK_IMPORTED_MODULE_13__["default"].getContractIds(contracts)
          }
        }, options);
        return _utils_tc_vars__WEBPACK_IMPORTED_MODULE_12__["default"].set(tagData);
      }
      /**
       * Store the `oauth` and `send` setup options for later use.
       *
       * @private
       *
       * @param  {Object}  options The setup options
       * @return {Promise}         Bluebird promise which resolves if the options were successfully stored
       */

      function storeOptions(options) {
        _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].debug('Saving options', options);
        return Promise.all([(0, _utils_store__WEBPACK_IMPORTED_MODULE_14__.getCache)().setItem('oauth', options.oauth), (0, _utils_store__WEBPACK_IMPORTED_MODULE_14__.getCache)().setItem('send', options.send)])["catch"](function (error) {
          _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].warn('Could not store bytel-tag-commander options', error);
          throw error;
        });
      }
      /**
       * Send connection request to OAuth server.
       *
       * @private
       *
       * @return {Promise}  Bluebird promise which resolves either way.
       *                    If the connection succeeds the promise is resolved with the access token else it resolves with `null`
       */

      function connect(options) {
        _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].debug('Connecting to OAuth server');
        if (options.accessToken) {
          _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].debug('Detected accessToken in options');
          var payload;
          if (options.idToken) payload = _bytel_bytel_oauth__WEBPACK_IMPORTED_MODULE_10___default().decodeToken(options.idToken);else if (options.id_personne && options.user_type) {
            var id_personne = options.id_personne,
              user_type = options.user_type;
            payload = {
              id_personne: id_personne,
              user_type: user_type
            };
          }
          if (!payload) return Promise.reject(new Error('Could not parse JWT payload'));
          return storeOAuthData({
            payload: payload,
            accessToken: options.accessToken
          }).then(function (accessToken) {
            return accessToken;
          })["catch"](function (error) {
            _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].warn('Could not connect OAuth:', error);
            return null;
          });
        }
        return _bytel_bytel_oauth__WEBPACK_IMPORTED_MODULE_10___default().request(options).then(function (data) {
          return storeOAuthData(data);
        })["catch"](function (error) {
          _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].warn('Could not connect OAuth:', error);
          return null;
        });
      }
      /**
       * Store OAuth response data in localStorage
       *
       * @param {any} { payload, accessToken }
       * @returns
       */

      function storeOAuthData(_ref) {
        var payload = _ref.payload,
          accessToken = _ref.accessToken;
        if (!payload || !accessToken) return Promise.reject(new Error('Missing oauth data'));
        var data = [(0, _utils_store__WEBPACK_IMPORTED_MODULE_14__.getCache)().setItem('jwt-data', payload), (0, _utils_store__WEBPACK_IMPORTED_MODULE_14__.getCache)().setItem('user-type', payload.user_type), (0, _utils_store__WEBPACK_IMPORTED_MODULE_14__.getCache)().setItem('access-token', accessToken)];
        if (payload.id_personne) data.push((0, _utils_store__WEBPACK_IMPORTED_MODULE_14__.getCache)().setItem('person-id', payload.id_personne));
        return Promise.all(data).then(function () {
          return accessToken;
        });
      }
      /**
       * Send tag data using tag commander. The `send` setup option will be used to determine how to send the data.
       *
       * @private
       *
       * @return {Promise}  Bluebird promise which resolves either way. An error will be posted to the console if it fails
       *                    it fails to execute the tag commander method. If the `send` setup option is a `Function` it will
       *                    not try to catch any errors.
       */

      function sendTag(options) {
        var opt = _objectSpread(_objectSpread({}, window.tc_vars), options);
        _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].debug('Data fetched. Sending tag data:', opt);
        return (0, _utils_store__WEBPACK_IMPORTED_MODULE_14__.getCache)().getItem('send').then(function (send) {
          if (lodash_isFunction__WEBPACK_IMPORTED_MODULE_3___default()(send)) return send(opt);else {
            try {
              var type = 'data-layer-ready'; // page tag

              var event = lodash_toLower__WEBPACK_IMPORTED_MODULE_5___default()(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(options, 'event', ''));
              var actionClick = lodash_toLower__WEBPACK_IMPORTED_MODULE_5___default()(lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(options, 'actionClic', ''));
              var isImpression = lodash_includes__WEBPACK_IMPORTED_MODULE_4___default()(['impression', 'impressions'], actionClick);
              var hasClickName = lodash_has__WEBPACK_IMPORTED_MODULE_1___default()(options, 'nomClic');
              var hasImpressionName = lodash_has__WEBPACK_IMPORTED_MODULE_1___default()(options, 'nomImp'); // action done by the user

              if (event === eventTypes.click || hasClickName && !isImpression && (!event || event !== eventTypes.impression)) {
                type = eventTypes.click; // action done without user intervention
              } else if (event === eventTypes.impression || hasImpressionName || isImpression) {
                type = eventTypes.impression;
              }
              _utils_trackingHistory__WEBPACK_IMPORTED_MODULE_17__["default"].sendEvent(type, options);
              window[send](window, type, options);
            } catch (error) {
              _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].error("Could not execute tag commander method '".concat(send, "'"), error);
            }
          }
        });
      }
      /**
       * standardize vars
       *
       * @param {Object} options tracking vars to be processed
       * @return {Object} standardized tracking vars
       */

      function standardizeVars(options) {
        var standardizedVars = {};
        lodash_forEach__WEBPACK_IMPORTED_MODULE_8___default()(STANDARDIZED_VAR_NAMES, function (varName) {
          var varValue = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(options, varName);
          if (varValue) {
            switch (varName) {
              case STANDARDIZED_VAR_NAMES.PAGE_VARIANTE:
                // do nothing if varName equals to PAGE_VARIANTE (https://jira.bouyguestelecom.fr/browse/DIGFACT-38328)
                // if (typeof varValue === 'object') {
                //   const standardizedVariantPage = {}
                //   // standardizes each variant page values
                //   forEach(varValue, (propValue, propName) => {
                //     standardizedVariantPage[propName] = standardizeVar(propValue)
                //   })
                //   if (!isEmpty(standardizedVariantPage)) {
                //     standardizedVars[varName] = standardizedVariantPage
                //   }
                // }
                break;
              case STANDARDIZED_VAR_NAMES.ACTIVITE:
                // force activity to be upper case
                options[varName] = lodash_toUpper__WEBPACK_IMPORTED_MODULE_6___default()(varValue); // remove prop if it does not match with activities

                if (!lodash_includes__WEBPACK_IMPORTED_MODULE_4___default()(ACTIVITIES, options[varName])) {
                  options = lodash_omit__WEBPACK_IMPORTED_MODULE_9___default()(options, varName);
                }
                break;
              default:
                standardizedVars[varName] = standardizeVar(varValue);
            }
          }
        });
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_7___default()(standardizedVars)) {
          options = lodash_extend__WEBPACK_IMPORTED_MODULE_2___default()(options, standardizedVars);
        }
        return options;
      }
      /**
       * standardize var
       *
       * @param {String} str the string to be processed
       * @return {String} the standardized string
       */

      function standardizeVar(str) {
        if (!str && typeof str !== 'boolean') return '';
        var res = str.toString().toLowerCase(); // remove accents

        res = removeAccents(res); // replace special characters by underscore character

        res = res.replace(/[^\da-z]/g, '_'); // trim underscores into one in the string

        res = res.replace(/__+/g, '_'); // trim underscores on the left and the right of the string

        res = res.replace(/^_+/, '').replace(/_+$/, ''); // sentence case

        res = res[0].toUpperCase() + res.slice(1).toLowerCase();
        return res;
      }
      /**
       * Remove accents in the string
       *
       * @param {String} str the string to be processed
       * @return {String} the string without accent
       */

      function removeAccents(str) {
        var DIACRITICS_MAP = {};
        DEFAULT_DIACRITICS_REMOVAL_MAP.forEach(function (_ref2) {
          var base = _ref2.base,
            letters = _ref2.letters;
          var _iterator = _createForOfIteratorHelper(letters),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var letter = _step.value;
              DIACRITICS_MAP[letter] = base;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
        return str.replace(/[^\u0000-\u007E]/g, function (a) {
          return DIACRITICS_MAP[a] || a;
        });
      }
      /**
       * Setup the `bytel-api` library.
       *
       * @private
       *
       * @param  {String} host        The API host URL
       * @param  {String} accessToken OAuth access token
       * @return {null}               Returns `null` to prevent Bluebird from printing warnings
       */

      function apiSetup(_x, _x2, _x3) {
        return _apiSetup.apply(this, arguments);
      }
      function _apiSetup() {
        _apiSetup = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(host, cache, accessToken) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _utils_log__WEBPACK_IMPORTED_MODULE_16__["default"].debug('Setting up API');
                  _context2.next = 3;
                  return _utils_api__WEBPACK_IMPORTED_MODULE_15__["default"].setup({
                    host: host,
                    cache: cache,
                    accessToken: accessToken
                  });
                case 3:
                  return _context2.abrupt("return", null);
                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return _apiSetup.apply(this, arguments);
      }
    })();

    /******/
    return __webpack_exports__;
    /******/
  })();
});
